/* Blog post helpers: table of contents from H2 headings, and "Copy link". */
(() => {
  const slug = (text) => text.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';

  const buildToc = () => {
    document.querySelectorAll('[data-article-toc]').forEach((toc) => {
      const content = toc.closest('article')?.querySelector('[data-article-content]');
      if (!content) return;
      const headings = [...content.querySelectorAll('h2')].filter((h) => h.textContent.trim());
      if (headings.length < Number(toc.dataset.min || 3)) return;
      const list = toc.querySelector('ol');
      list.replaceChildren();
      const used = new Set();
      headings.forEach((heading) => {
        if (!heading.id) {
          let id = slug(heading.textContent);
          while (used.has(id) || document.getElementById(id)) id += '-2';
          heading.id = id;
        }
        used.add(heading.id);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-copy-link]');
    if (!button) return;
    const done = () => {
      const original = button.textContent;
      button.textContent = button.dataset.copied || 'Link copied';
      setTimeout(() => { button.textContent = original; }, 2000);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(button.dataset.copyLink).then(done).catch(() => {});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildToc);
  else buildToc();
  document.addEventListener('shopify:section:load', buildToc);
})();
